module.exports = __webpack_public_path__ + "fonts/279393d.otf";